// extracted by mini-css-extract-plugin
export default {"wrapper":"Editor_wrapper__Qpa5s","paint":"Editor_paint__KfnMP","canvasWrap":"Editor_canvasWrap__ZCe3B","close":"Editor_close__3OxDq"};